import * as React from 'react';
import { Table } from '../../../../components/tables/Table';
import { DealerContact } from '../../../../support/models/dealers/dealer-read';
import { DealerContactRow } from './DealerContactRow';

interface IProps {
    contacts: DealerContact[];
}

export const DealerContactTable = (props: IProps) => {

    return <React.Fragment>

                <div className="row">
                    <div className="col-md-12">
                        <Table
                            tableClass="center-last-column"
                            transparentBackground={true}
                            noResultsMessage="This dealer has no contacts defined."
                            header={['Legacy ID', 'Name', 'Email', 'Fax', 'Preferences']}>
                            {
                                props.contacts.map((itm: DealerContact, idx: number) => {
                                    return <DealerContactRow 
                                            key={idx} 
                                            contact={itm}  />;
                                })
                            }
                        </Table>
                    </div>
                </div>
            </React.Fragment>;

};
